import React from 'react';
import { Navigate } from 'react-router-dom';
import { Box, withStyles } from '@material-ui/core';
import { FolderNav, Loader, Theme } from '@orijinworks/frontend-commons';
import styles from './ReentryPlanningModule.styles';
import ReentryPlansTable from './components/ReentryPlansTable';
import { REENTRY_PLANNING_TABS } from './constants/reentry-planning.constants';
import withRolePermission from '../Feeds/withRolePermission';
import {
  ACCESS_STATUS,
  useReentryPlanningModuleHook,
} from './useReentryPlanningModuleHook';

function ReentryPlanningModule({ classes }) {
  const {
    accessStatus,
    activeTab,
    lastRefreshed,
    onTabChange,
    refreshPlans,
    tabs,
  } = useReentryPlanningModuleHook();

  if (accessStatus === ACCESS_STATUS.DENIED) {
    return <Navigate to="/home" replace />;
  }

  if (accessStatus === ACCESS_STATUS.PENDING) {
    return <Loader isLoading />;
  }

  return (
    <Theme>
      <Box
        className={classes.application}
        role="main"
        aria-label="Re-Entry Planning"
        id="reentry-plans-content"
      >
        <Box className={classes.folderWrapper}>
          <FolderNav
            scrollButtons={false}
            tabFontColor="var(--blue-main)"
            tabs={tabs}
            defaultActiveTab={activeTab}
            onTabChange={onTabChange}
            role="tablist"
            aria-label="Re-Entry Planning navigation tabs"
          >
            {activeTab === REENTRY_PLANNING_TABS.ALL_PLANS && (
              <Box
                role="tabpanel"
                aria-labelledby="all-plans-tab"
                id="all-plans-panel"
                className={classes.tabPanel}
              >
                <ReentryPlansTable
                  lastRefreshed={lastRefreshed}
                  onRefreshHandler={refreshPlans}
                />
              </Box>
            )}
          </FolderNav>
        </Box>
      </Box>
    </Theme>
  );
}

const StyledReentryPlanningModule = withStyles(styles)(ReentryPlanningModule);

export default withRolePermission(StyledReentryPlanningModule);
